module.exports = __webpack_public_path__ + "static/media/Header1.0c38b1dd.jpg";